import { useCallback } from 'react';
import { BaseFormModal } from '@/components/BaseFormModal';

export interface UserHelpModalProps {
  open: boolean;
  title?: string;
  subject?: string;
  message?: string;
  theme?: string;
  onClose: () => void;
}

export function UserHelpModal({
  open,
  title = 'Help',
  subject = '',
  message = '',
  theme,
  onClose,
}: UserHelpModalProps) {
  const handleClose = useCallback(() => {
    onClose();
  }, [onClose]);

  return (
    <BaseFormModal
      open={open}
      title={title}
      theme={theme}
      dialogClass="kstc-dialog--form"
      showSave={false}
      cancelText="OK"
      onCancel={handleClose}
    >
      <div className="kst-help-content">
        {subject && (
          <p className="kst-help-subject">
            <strong>{subject}</strong>
          </p>
        )}
        <div
          className="kst-help-message"
          dangerouslySetInnerHTML={{ __html: message }}
        />
      </div>
    </BaseFormModal>
  );
}

(window as any).UserHelpModalReact = UserHelpModal;
